/* Kallov: Ship to, in the header.

   The locale selector already exists and is driven entirely by Shopify
   Markets. It lives in the footer floor, which means a reader in Lagos or
   London sees dollar prices until she scrolls past the entire page. This puts
   a second trigger in the header row, beside search and the bag, and points it
   at the dialog the footer already renders. One dialog, two ways in. Nothing
   about the footer's own trigger changes.

   Track Your Order is not touched here. It belongs in the footer directory
   with the other pages, under Orders and Delivery, and the floor rule carries
   the shipping destination and the copyright only.

   The header trigger is built here rather than in sections/header.liquid
   because that file is 24KB of vendor theme code, and a header that fails to
   render takes the whole site with it. If this script never runs, the footer
   selector still works exactly as it does today.

   It also repairs one real defect on the way past. See below. */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function idOf(el) {
    return el ? el.getAttribute('id') || '' : '';
  }

  /* The country rows carry data-kls-name for the search filter, written as
     {{ country.name | escape }}. Shopify already returns those names escaped,
     so the eleven countries with an ampersand in their name come out doubly
     escaped: the attribute reads "Trinidad &amp; Tobago" while the visible
     label reads "Trinidad & Tobago". Typing the country's actual name finds
     nothing. Antigua & Barbuda, Bosnia & Herzegovina, St. Kitts & Nevis,
     St. Vincent & Grenadines, St. Pierre & Miquelon, Sao Tome & Principe,
     South Georgia & South Sandwich Islands, Svalbard & Jan Mayen,
     Trinidad & Tobago, Turks & Caicos Islands, Wallis & Futuna.

     The permanent fix is escape_once in snippets/kallov-locale-selector.liquid.
     This repairs the rendered attribute so the search works today. */
  function repairNames(root) {
    var rows = root.querySelectorAll('[data-kls-name]');
    for (var i = 0; i < rows.length; i++) {
      var v = rows[i].getAttribute('data-kls-name');
      if (v && v.indexOf('&amp;') !== -1) {
        rows[i].setAttribute('data-kls-name', v.replace(/&amp;/g, '&'));
      }
    }
  }

  function textOf(root, selector) {
    var el = root.querySelector(selector);
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function buildHeader(dialog, source) {
    var host = document.querySelector('.header__secondary-nav > ul');
    if (!host || host.querySelector('.kls-head')) return;

    var place = textOf(source, '.kls__place');
    /* .kls__meta opens with a middot and may carry a language before the
       currency. Take what is after the last separator, which is always the
       currency. */
    var meta = textOf(source, '.kls__meta');
    var parts = meta.split('·');
    var currency = parts[parts.length - 1].trim();

    if (!place && !currency) return;

    var li = document.createElement('li');
    li.className = 'header__shipto-link kls-head';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kls-head__btn';
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.setAttribute('aria-controls', idOf(dialog));

    var sr = document.createElement('span');
    sr.className = 'kls-head__sr';
    sr.textContent = 'Change where you are shipping to. Currently ' + place + '.';

    var placeEl = document.createElement('span');
    placeEl.className = 'kls-head__place';
    placeEl.textContent = place;

    var dot = document.createElement('span');
    dot.className = 'kls-head__dot';
    dot.setAttribute('aria-hidden', 'true');
    dot.textContent = '·';

    var curEl = document.createElement('span');
    curEl.className = 'kls-head__cur';
    curEl.textContent = currency;

    btn.appendChild(sr);
    btn.appendChild(placeEl);
    btn.appendChild(dot);
    btn.appendChild(curEl);
    li.appendChild(btn);

    host.insertBefore(li, host.firstChild);

    btn.addEventListener('click', function () {
      if (typeof dialog.showModal !== 'function') return;
      dialog.showModal();
      document.body.classList.add('kls-locked');
      var title = dialog.querySelector('.kls__title');
      if (title) {
        title.setAttribute('tabindex', '-1');
        title.focus({ preventScroll: true });
      }
    });

    dialog.addEventListener('close', function () {
      document.body.classList.remove('kls-locked');
    });
  }

  ready(function () {
    var dialog = document.querySelector('dialog.kls__dialog');
    if (!dialog) return;
    repairNames(dialog);
    var source = document.querySelector('.kls__trigger');
    if (source) buildHeader(dialog, source);
  });
})();
